import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { ReportsModel } from "@shared/interfaces/reports";
import { GET_BDM_AGENT_LIST } from "@store/campaign/campaign.action";
import { CampaignService } from "@store/campaign/campaign.service";
import { ProfileService } from "@store/profile/profile.service";
import { map } from "rxjs/operators";

import {
  DOWNLOAD_PERFORMANCE_REPORT,
  GET_CAMPAIGN_REPORT,
  GET_PERFORMANCE_REPORT,
  GET_REPORT_YEAR,
  GET_REPORTS_BDM_AGENT,
  GET_REPORTS_BRANCH_AGENT,
  GET_REPORTS_LOV,
} from "./sales-management-reports.action";
import { SalesManagementReportsService } from "./sales-management-reports.service";

@State<ReportsModel>({
  name: "SalesManagementReportsState",
  defaults: {
    lov: null,
    bdmAgentList: null,
    branchAgentList: null,
    campaignReport: null,
    performanceReport: null,
    performanceReportPdf: null,
    reportYear: null,
  },
})
@Injectable()
export class SalesManagementReportsState {
  constructor(
    private readonly SalesManagementReportsService: SalesManagementReportsService,
    private readonly profileService: ProfileService,
    private readonly campaignService: CampaignService,
    private readonly store: Store,
  ) {}

  @Selector()
  public static reportsLov(state: ReportsModel) {
    return state.lov ? state.lov : null;
  }

  @Selector()
  public static reportsUserType(state: ReportsModel) {
    return state.lov.USERTYPE ? state.lov.USERTYPE : null;
  }

  @Selector()
  public static branchAgentList(state: ReportsModel) {
    return state.branchAgentList ? state.branchAgentList : null;
  }

  @Action(GET_REPORTS_LOV)
  public getReportsLov(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_REPORTS_LOV,
  ) {
    return this.SalesManagementReportsService.getReportsLov(payload).pipe(
      map((res) => {
        patchState({
          lov: res.data ? res.data : null,
        });
      }),
    );
  }

  @Action(GET_REPORTS_BDM_AGENT)
  public getBdmAgentList(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_BDM_AGENT_LIST,
  ) {
    return this.campaignService.getBdmAgentList(payload).pipe(
      map((res) => {
        patchState({
          bdmAgentList: res,
        });
      }),
    );
  }

  @Action(GET_REPORT_YEAR)
  public getReportYear(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_REPORT_YEAR,
  ) {
    return this.SalesManagementReportsService.getReportYear(payload).pipe(
      map((res) => {
        patchState({
          reportYear: res,
        });
      }),
    );
  }

  @Action(GET_REPORTS_BRANCH_AGENT)
  public getBranchAgentList(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_REPORTS_BRANCH_AGENT,
  ) {
    return this.profileService.getFilteredAgentList(payload).pipe(
      map((res) => {
        patchState({
          branchAgentList: res.agentList,
        });
      }),
    );
  }

  @Action(GET_CAMPAIGN_REPORT)
  public getCampaignReport(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_CAMPAIGN_REPORT,
  ) {
    return this.SalesManagementReportsService.getCampaignReport(payload).pipe(
      map((response) => {
        if (response) {
          patchState({
            campaignReport: response,
          });
        } else {
          patchState({
            campaignReport: null,
          });
        }
      }),
    );
  }

  @Action(GET_PERFORMANCE_REPORT)
  public getPerformanceReport(
    { patchState }: StateContext<ReportsModel>,
    { payload }: GET_PERFORMANCE_REPORT,
  ) {
    return this.SalesManagementReportsService.getPerformanceReport(
      payload,
    ).pipe(
      map((res) => {
        patchState({
          performanceReport: res.dataList ? res : null,
        });
      }),
    );
  }

  @Action(DOWNLOAD_PERFORMANCE_REPORT)
  public downloadPerformanceReport(
    { patchState }: StateContext<ReportsModel>,
    { payload }: DOWNLOAD_PERFORMANCE_REPORT,
  ) {
    const USER_ID = this.store.selectSnapshot<any>(
      (state) => state.UserState.user.userId,
    );

    return this.SalesManagementReportsService.downloadPerformanceReport(
      USER_ID,
      payload,
    ).pipe(
      map((res) => {
        if (res) {
          patchState({
            performanceReportPdf: res,
          });
        }
        // patchState({
        //     performanceReport: res.dataList ? res : null
        // })
      }),
    );
  }
}
